import { useEffect, useState } from "react";

const readInsets = (probe) => {
  if (!probe) return { top: 0, right: 0, bottom: 0, left: 0 };
  const computed = window.getComputedStyle(probe);
  return {
    top: parseFloat(computed.paddingTop) || 0,
    right: parseFloat(computed.paddingRight) || 0,
    bottom: parseFloat(computed.paddingBottom) || 0,
    left: parseFloat(computed.paddingLeft) || 0,
  };
};

const createProbe = () => {
  const probe = document.createElement("div");
  probe.style.cssText =
    "position:fixed;top:0;left:0;width:0;height:0;visibility:hidden;pointer-events:none;" +
    "padding:env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);";
  document.body.appendChild(probe);
  return probe;
};

const measure = (probe) => ({
  width: window.innerWidth,
  height: window.innerHeight,
  insets: readInsets(probe),
});

export default function useViewport() {
  const [viewport, setViewport] = useState(() => measure(null));

  useEffect(() => {
    const probe = createProbe();
    let frame = 0;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setViewport(measure(probe)));
    };
    update();
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      probe.remove();
    };
  }, []);

  return viewport;
}
